export const partnerConsents = {
  dealerConsent: "VCP_DealerConsent",
  customerConsent: "VCP_CustomerConsent",
};
